/**
 * 낭만월운 PC 표지 목차 카드 정의
 *
 * - theme: 카드 배경 톤 (green/yellow/pink/blue/white)
 * - isPaid: 유료 여부
 * - typeId: 유료 카드의 백엔드 analysisTypeId (parentId=10 children)
 *           - 가격(pointPrice)과 권한 판정은 typeId 기반으로 처리하며,
 *             tocCards 정적 정의에는 가격을 두지 않는다.
 * - drawer: 우측 슬라이드 드로어에 매핑할 컨텐츠 식별자
 *
 * 카드는 항상 한 줄에 한 개씩 표시한다.
 */

/** 카드 key → 백엔드 자식 analysisTypeId 매핑 (parentId=10 기준) */
export const MONTHLY_FORTUNE_CARD_TYPE_ID = {
  romanceStyle: 42, // 낭만월운_연애
  money: 43, // 낭만월운_재물
  capability: 44, // 낭만월운_업무
  caution: 45, // 낭만월운_조심
  mode: 46, // 낭만월운_모드
};

/** 낭만월운 부모 typeId (전체 구매) */
export const MONTHLY_FORTUNE_PARENT_TYPE_ID = 10;

/**
 * 자식 카드 typeId → 응답 데이터의 카테고리 번호 매핑.
 * base-service 호출 시 suggestionFlag 로 전달할 값이다.
 * (응답 키는 "7_연애스타일", "8_돈관리" … 형태)
 */
export const MONTHLY_FORTUNE_CATEGORY_NUMBER_BY_TYPE_ID = {
  [MONTHLY_FORTUNE_CARD_TYPE_ID.romanceStyle]: 7,
  [MONTHLY_FORTUNE_CARD_TYPE_ID.money]: 8,
  [MONTHLY_FORTUNE_CARD_TYPE_ID.capability]: 9,
  [MONTHLY_FORTUNE_CARD_TYPE_ID.caution]: 10,
  [MONTHLY_FORTUNE_CARD_TYPE_ID.mode]: 11,
};


export const MONTHLY_FORTUNE_TOC_CARDS = [
  {
    key: 'letter',
    emoji: '🌙',
    title: '낭만 편지',
    description: '',
    theme: 'green',
    isPaid: false,
    drawer: 'letter',
  },
  {
    key: 'energy',
    emoji: '⚡',
    title: '오행으로 보는 내 컨디션',
    description: '',
    theme: 'green',
    isPaid: false,
    drawer: 'energy',
  },
  {
    key: 'capability',
    emoji: '💡',
    title: '이 달, 어떤 내 모습이 빛날 수 있을까?',
    description: '내가 가진 좋은 기운',
    randomSubs: [
      '이 달엔 어떤 강점을 살려볼까요?',
      '의외로 잘 되는 것이 있어요',
      '강점에 집중하면 하루가 달라져요',
      '지금 잘하고 있는 거, 알고 계세요?',
      '못하는 것보다, 이 달 좋은 기운에 집중해볼까요?',
      '사주가 알려주는, 이 달 내가 빛나는 자리',
      '같은 일도 더 수월하게 풀리는 영역이 있어요',
      '평소엔 무뎠는데, 이 달엔 감이 좋은 것',
      '노력한 만큼, 이 달엔 더 잘 풀리는 일',
      '이 달, 사주가 내 편이 되어주는 자리',
    ],
    theme: 'white',
    isPaid: true,
    typeId: MONTHLY_FORTUNE_CARD_TYPE_ID.capability,
    drawer: 'capability',
  },
  {
    key: 'lucky',
    emoji: '🍀',
    title: '행운 카드',
    description: '나를 채워주는 4가지',
    randomSubs: [
      '나를 채워주는 4가지',
      '컬러 · 식탁 · 활동 · 낭만',
      '균형을 맞추는 오행 레시피',
      '이번 달, 나의 행운 카드',
      '오행이 추천하는 행운카드',
      '나를 채워주는 작은 것들',
      '입고 먹고 즐기는 이 달의 행운',
      '내 기운을 살려주는 행운카드',
      '오행이 짚어주는 작은 디테일',
      '이 달, 컬러부터 한 끼까지',
    ],
    theme: 'yellow',
    isPaid: false,
    drawer: 'lucky',
  },
  {
    key: 'mode',
    emoji: '🌟',
    title: '기운 따라 달라지는 나',
    description: '달마다 달라지는 내 감정 지수',
    randomSubs: [
      '달마다 달라지는 내 감성 지수',
      '이번 달 나는 어떤 캐릭터?',
      '사주로 보는 내 성격 변화',
      '매달 감성 포인트가 달라질 수 있어요',
      '이번 달, 나도 모르게 달라진 것들',
      '이 달의 나는, 평소와 같을까 다를까?',
      '평소보다 더 신중해진 나, 더 가벼워진 나',
      '평소 같지 않게 느껴진다면, 이유가 있어요',
      '사주가 이 달의 나에게 붙여준 또 하나의 이름',
      '똑같은 나지만, 달마다 감성이 같진 않아요',
    ],
    theme: 'yellow',
    isPaid: true,
    typeId: MONTHLY_FORTUNE_CARD_TYPE_ID.mode,
    drawer: 'mode',
  },
  {
    key: 'money',
    emoji: '💰',
    title: '소비위험일 · 알뜰쇼핑 · 재물팁',
    description: '잘 쓰고, 잘 관리해볼까?',
    randomSubs: [
      '내 지갑, 이번 달은 괜찮을까?',
      '이상하게 충동구매 하게 되는 날이 있어요',
      '돈이 새는 날, 모이는 날',
      '큰 결정 앞에 있다면, 잠깐',
      '알뜰하게 쇼핑하기 좋은 날은?',
      '정보도 돈이에요. 이달의 재물 흐름',
      '결제 버튼 누르기 전, 한 번 더 보세요',
      '큰돈 쓰기 전, 사주가 알려주는 한마디',
      '이왕이면, 찾아보고 챙기는 쪽으로',
      '이 달, 내 지갑의 좋은 날과 위험한 날',
    ],
    theme: 'white',
    isPaid: true,
    typeId: MONTHLY_FORTUNE_CARD_TYPE_ID.money,
    drawer: 'money',
  },
  {
    key: 'health',
    emoji: '💪',
    title: '내 건강은 내가 챙겨야지!!',
    description: '오행이 알려주는 내 몸 사용법',
    randomSubs: [
      '오행이 알려주는 내 몸 사용법',
      '알아두면 챙기게 돼요',
      '내 몸이 보내는 작은 변화',
      '이번 달, 특히 챙겨야 할 부위는?',
      '몸이 먼저 알려주는 것들',
      '무리하면 티 나는 자리, 미리 알아두기',
      '사주로 미리 보는 이 달의 컨디션',
      '작은 피로가 쌓이기 전, 미리 챙기는 게 있어요',
      '내 몸의 약한 고리, 이 달엔 어디일까요?',
      '컨디션 흔들리기 쉬운 날, 미리 알면 덜 무리해요',
    ],
    theme: 'white',
    isPaid: false,
    drawer: 'health',
  },
  {
    key: 'romance',
    emoji: '💕',
    title: '내 연애 감정',
    description: '',
    theme: 'pink',
    isPaid: false,
    drawer: 'romance',
  },
  {
    key: 'romanceStyle',
    emoji: '💝',
    title: '이 달, 내 연애 스타일은?',
    description: '좋은 날 · 필요한 감성',
    randomSubs: [
      '좋은 날 · 필요한 감성',
      '데이트 하기 좋은 날이 있어요',
      '내가 예민해지는 달인가?',
      '설레는 만큼, 한 템포 더 여유를',
      '이번 달, 내가 필요한 감성은?',
      '마음 가는 결도, 매달 살짝 달라요',
      '데이트 좋은 날, 감정 과한 날 따로 있어요',
      '표현하면 통하는 날 vs 묻어두는 게 나은 날',
      '사랑도 롤러코스터 같을 때가 있어요',
      '솔직해질 날, 한 박자 쉴 날, 사주가 짚어줘요',
    ],
    theme: 'pink',
    isPaid: true,
    typeId: MONTHLY_FORTUNE_CARD_TYPE_ID.romanceStyle,
    drawer: 'romanceStyle',
  },
  {
    key: 'caution',
    emoji: '🔍',
    title: '뭔가 조심해야 할 게 있을까?',
    description: '알고 넘어가면 수월해져요',
    randomSubs: [
      '알고 넘어가면 수월해져요',
      '미리 알면 더 편안해지는 것들',
      '한 번 더 생각하면 피할 수 있어요',
      '괜히 불안하다면, 확인해보세요',
      '조심할 건 조심하고, 편할 건 편하게',
      '사주가 살짝 짚어주는 이 달의 체크포인트',
      '이 달, 작은 마찰이 생기기 쉬운 영역',
      '무심코 부딪힐 수 있는 작은 순간들',
      '맘 편한 게 최고, 미리 챙길 거 있을까요?',
      '큰일은 아니지만, 알아두면 든든한 것들',
    ],
    theme: 'white',
    isPaid: true,
    typeId: MONTHLY_FORTUNE_CARD_TYPE_ID.caution,
    drawer: 'caution',
  },
  {
    key: 'nextMonth',
    emoji: '👀',
    title: '다음 달, 살짝 엿보기',
    description: '',
    theme: 'blue',
    isPaid: false,
    drawer: 'nextMonth', // 드로어가 아니라 팝업이지만 식별용
  },
];

/** 페이지 진입 시 카드별 랜덤 서브 카피를 1회 픽한다. (key → string) */
export const pickRandomCardSubs = () => {
  const picked = {};
  MONTHLY_FORTUNE_TOC_CARDS.forEach((card) => {
    if (Array.isArray(card.randomSubs) && card.randomSubs.length > 0) {
      const idx = Math.floor(Math.random() * card.randomSubs.length);
      picked[card.key] = card.randomSubs[idx];
    }
  });
  return picked;
};
